
export default {
  name: 'BaseNavigatorStreamStreamsList',
  props: {
    streams: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      inputValue: '',
    }
  },
  methods: {
    findStreams(str) {
      this.$emit('search', str)
    },
  },
}
